var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.token)?_c('div',{staticClass:"l-layout"},[_c('header-section'),_c('transition',{attrs:{"name":"fade"}},[(_vm.getCustomersPopup)?_c('customers-popup'):_vm._e()],1),_c('map-section')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }